import getMsisdnWithoutPrefix from './getMsisdnWithoutPrefix'; 

export default (msisdn: string) => {
  return getMsisdnWithoutPrefix(msisdn).replace(/(.{3})/g, '$1 ').trim();
};
